/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const sort = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.051 2v11.115m0 0L6.667 10.5M4.05 13.115 1.436 10.5m10.461 2.833V2.218m0 0L9.282 4.833m2.615-2.615 2.616 2.615"
    />
  </svg>
)
export default sort
